import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { Carate, Restriction } from 'lumen/models';
import type { HoteldateTransformReturn } from 'lumen/transforms/hoteldate';
import type { RestrictionModelContextsType } from 'lumen/utils/constants/channel-pricing-constants';
import type {
  OVERRIDE_TYPES,
  OverrideTypes,
} from 'lumen/utils/constants/pricing-assistant-constants';

export interface OverrideBase<TType, TValue> {
  id: string;
  type: TType;
  value: TValue;
}

export type ExactPriceOverride = OverrideBase<
  typeof OVERRIDE_TYPES.EXACT_PRICE,
  number
>;
export type DiscountOverride = OverrideBase<
  typeof OVERRIDE_TYPES.DISCOUNT,
  number
>;
export type PriceRangeOverride = OverrideBase<
  typeof OVERRIDE_TYPES.PRICE_RANGE,
  { maximum: number; minimum: number }
>;
export type OverbookingOverride = OverrideBase<
  typeof OVERRIDE_TYPES.OVERBOOKING,
  number
>;
export type MinLosOverride = OverrideBase<
  typeof OVERRIDE_TYPES.MIN_LOS,
  number
>;

export default class Override extends Model {
  [Type] = 'override' as const;

  @belongsTo('restriction', { async: false, inverse: 'overrides' })
  declare restriction: Restriction | null;
  @hasMany('carate', { async: false, inverse: 'override' })
  declare carates: Carate[];

  @attr('string') declare context?: RestrictionModelContextsType;
  @attr('hoteldate') declare fromDate: NonNullable<HoteldateTransformReturn>;

  @attr('string') declare pmsRoomtype: string;
  @attr('string') declare rateCode: string;
  @attr('string') declare rateGroupId: string | null;
  @attr('string') declare type: OverrideTypes;
  @attr() declare value: number | { maximum: number; minimum: number };
}
